module.exports = __webpack_public_path__ + "static/media/Heebo-Medium.5534e6a9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Medium.woff2
// module id = 781
// module chunks = 0